// extracted by mini-css-extract-plugin
export default {"sectionServices":"style_sectionServices__sSelE"};